import { clsx } from 'clsx';
import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Input } from '@treezor/design-system';

import { IChangePasswordForm } from '@/features/dashboard-users/store/types/password.types';

interface IChangePasswordFormProps {
  currentPasswordWatch?: string;
  newPasswordWatch: string;
  confirmNewPasswordWatch: string;
  isNewAndConfirmPasswordTheSame: boolean;
  isNewPasswordDifferentFromCurrent?: boolean;
  isCurrentPasswordRequired?: boolean;
  handleInputChange: (
    field: keyof IChangePasswordForm,
    event: React.SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  className?: string;
}

export function ChangePasswordForm({
  currentPasswordWatch,
  newPasswordWatch,
  confirmNewPasswordWatch,
  isNewAndConfirmPasswordTheSame,
  isNewPasswordDifferentFromCurrent,
  handleInputChange,
  className,
  isCurrentPasswordRequired = true,
}: IChangePasswordFormProps) {
  const { t } = useTranslation();
  return (
    <div className={clsx('flex flex-col gap-5', className)}>
      {isCurrentPasswordRequired && (
        <Input
          type="password"
          size="m"
          label={t('pages.auth.changePassword.currentPassword')}
          required
          value={currentPasswordWatch}
          name="currentPassword"
          testId="input-current-password"
          onChange={(event: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) =>
            handleInputChange('currentPassword', event)
          }
        />
      )}
      <Input
        type="password"
        size="m"
        label={t('pages.auth.changePassword.newPassword')}
        required
        value={newPasswordWatch}
        name="newPassword"
        testId="input-new-password"
        onChange={(event: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) =>
          handleInputChange('newPassword', event)
        }
        error={
          isCurrentPasswordRequired && isNewPasswordDifferentFromCurrent === false && !!newPasswordWatch
            ? t('pages.auth.changePassword.errors.newPassword')
            : ''
        }
      />
      <Input
        type="password"
        size="m"
        label={t('pages.auth.changePassword.confirmNewPassword')}
        required
        value={confirmNewPasswordWatch}
        name="confirmNewPassword"
        testId="input-confirm-new-password"
        onChange={(event: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) =>
          handleInputChange('confirmNewPassword', event)
        }
        error={
          !isNewAndConfirmPasswordTheSame && !!confirmNewPasswordWatch
            ? t('pages.auth.changePassword.errors.confirmNewPassword')
            : ''
        }
      />
    </div>
  );
}
